import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-all-arrows-icon',
  templateUrl: './all-arrows-icon.component.html',
  styleUrls: ['./all-arrows-icon.component.scss'],
})
export class AllArrowsIconComponent {
  @Input() orientation: ArrowOrientation;
}

export type ArrowOrientation = 'left' | 'down' | 'up' | 'right' | 'minus';
